import React from "react";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

function DateFilter(props) {
  const { label, onDateChange, selectedDate, fieldId = "" } = props;

  const handleDatesChange = (date, fieldId) => {
    if (!isNaN(Date.parse(date))) {
      onDateChange(date, fieldId);
    }
  };
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        id={fieldId}
        disableFuture={props.disableFuture}
        disableToolbar
        autoOk={true}
        variant="inline"
        format="dd-MM-yyyy"
        label={label}
        value={selectedDate}
        onChange={(date) => handleDatesChange(date, fieldId)}
        minDate={props.minDate}
        margin={"dense"}
        inputVariant="outlined"
        maxDate={props.maxDate}
        style={{ width: 170 }}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
      />
    </MuiPickersUtilsProvider>
  );
}
export default DateFilter;
